import { getTouchRippleUtilityClass } from "@mui/material";
import axios from "axios";

const errorHandeler = (error) => {
  if (error.response) {
    // Запрос был сделан, и сервер ответил кодом состояния, который
    // выходит за пределы 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    return { data: error.response.data, status: error.response.status };
  } else if (error.request) {
    // Запрос был сделан, но ответ не получен
    // `error.request`- это экземпляр XMLHttpRequest в браузере и экземпляр
    // http.ClientRequest в node.js
    console.log(error.request);
    return error.request;
  } else {
    // Произошло что-то при настройке запроса, вызвавшее ошибку
    console.log("Error", error.message);
  }
  console.log(error.config);
};

const normalizeRes = (res) => {
  const { data, status } = res;

  return { data, status };
};

const getData = (url) => {
  return axios
    .get(url)
    .then((result) => normalizeRes(result))
    .catch((err) => errorHandeler(err));
};

const postData = async (url, data) => {
  return axios
    .post(url, data)
    .then((result) => {
      return normalizeRes(result);
    })
    .catch((err) => errorHandeler(err));
};
const putData = (url, data) => {
  return axios
    .put(url, data)
    .then((result) => {
      return normalizeRes(result);
    })
    .catch((err) => errorHandeler(err));
};

const deleteData = async (url, data) => {
  return axios
    .delete(url, data)
    .then((result) => {
      return normalizeRes(result);
    })
    .catch((err) => errorHandeler(err));
};

export { errorHandeler, normalizeRes, getData, postData, putData, deleteData };
